module.exports = __webpack_public_path__ + "img/04_no.88717b08.svg";